<form [formGroup]="form" class="form-inline">
  <div class="input-group">
    <div class="input-group-prepend">
      <input
        type="text"
        class="input-group-text form-field"
        placeholder="set interval value"
        formControlName="intervalValue"
        autocomplete="off"
      />
    </div>
    <select formControlName="intervalType" class="form-control form-field">
      <option *ngFor="let option of intervalTypes" [value]="option.value">
        {{ option.label }}
      </option>
    </select>
  </div>
</form>
